<template>
  <div
    v-cloak
    v-loading.fullscreen.lock="dataLoading"
    element-loading-text="Loading, please wait..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <el-dialog
      title="Config User Tag"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :center="true"
      @opened="opened"
      @close="closed"
      width="865px!important"
      size="small"
    >
      <div class="tab">
        <el-tabs class="el-tabs" type="border-card">
          <el-tab-pane label="Config Instance Tag">
            <el-row style="margin:0 30px 0 0">
              <p
                class="describe-title"
                style="border-bottom: #ccc 1px solid;padding-bottom:5px"
              >Tag Instance的配置 为用户对资源数据的过滤。表现为用户只能看到属于自己责任范围内的数据资源。</p>
            </el-row>
            <div>
              <span>请选择需要配置数据权限的角色：</span>
              <el-select
                style="margin:20px 0; width: 300px;"
                filterable
                clearable
                v-model="selectRole"
                placeholder="请选择角色"
                size="small"
                @change="changeRole"
              >
                <el-option
                  v-for="item in roleOption"
                  :key="item.id"
                  :label="item.roleName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
            <el-row style="max-height: 500px;overflow-y: auto" v-if="selectRole">
              <tree-select ref="instanceTree" :showReadWrite="showInstanceReadWriteCheckBox"></tree-select>
            </el-row>
          </el-tab-pane>

          <el-tab-pane label="Config Abstract Tag">
            <el-row style="margin:0 30px 0 0">
              <p class="describe-title" style="border-bottom: #ccc 1px solid;padding-bottom:5px">
                Tag Abstract的配置为用户对某种资源属性层级的操作。体现为用户对某种资源的部分属性的读写权限。
                默认情况下对资源的所有属性都有读写权限。
              </p>
            </el-row>
            <el-row style="max-height: 500px;overflow-y: auto">
              <tree-select
                ref="abstractTree"
                :showReadWrite="showAbstractReadWrite"
                :independent="abstractIndependent"
              ></tree-select>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="success" @click="save" :loading="saveLoading">Save</el-button>
        <el-button size="small" @click="dialogVisible = false" class="ml30">close</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import treeSelect from "@/view/acs/tree/tree_selection.vue";

export default {
  components: {
    treeSelect
  },
  props: {
    userId: {
      type: String,
      required: false,
      default: () => ""
    }
  },
  data() {
    return {
      dialogVisible: false,
      dataLoading: false,
      showAbstractReadWrite: true,
      showInstanceCheckBox: true,
      showInstanceReadWriteCheckBox: true,
      abstractIndependent: true,
      instanceTagStructure: [],
      abstractTagStructure: [],
      roleOption: [],
      selectRole: "",
      saveLoading:false
    };
  },
  computed: {},
  created() {},

  methods: {
    getRolesList(id) {
      console.log(id, "getRolesList");
      let url =
        this.baseAcsUrl + "/acs/user-role/get-role-list?userId=" + id;
      this.http
        .get(url, {})
        .then(resp => {
          console.log(resp, "pppppp");
          this.roleOption = resp.data;
          console.log(this.roleOption, "roles");
        })
        .catch(error => {
          this.$message.error("获取角色失败");
        });
    },
    changeRole(e) {
      //选择了role，再请求接口，获取对应的tree
      console.log(e, "changerole");
      this.selectRole = e;
      this.getTagInstance();
    },
    showDialog(id) {
      this.dialogVisible = true;
      this.roleOption = [];
      this.selectRole = "";
      this.getRolesList(id); //出现了弹窗再去获取roleList
    },
    opened() {
      if (this.instanceTagStructure.length) {
        this.$refs.instanceTree.init(
          this.instanceTagStructure,
          "tagName",
          "read",
          "write"
        );
        // this.getTagInstance();
      } else {
        // this.getTagInstance();
      }
      if (this.abstractTagStructure.length) {
        this.$refs.abstractTree.initIndependent(
          this.abstractTagStructure,
          "tagName",
          "read",
          "write"
        );
        this.getTagAbstract();
      } else {
        this.getTagAbstract();
      }
    },
    hideDialog() {
      this.dialogVisible = false;
    },
    getDataAbstractTag(structure, selectedTags) {
      structure.forEach(tree => {
        if (!tree.readChecked || !tree.writeChecked) {
          let tag = {};
          tag.dataTagId = tree.id;
          tag.isRead = tree.readChecked;
          tag.isWrite = tree.writeChecked;
          tag.isService = tree.isService;
          selectedTags.push(tag);
        }

        if (tree.children && tree.children.length) {
          this.getDataAbstractTag(tree.children, selectedTags);
        }
      });
    },

    save() {
      let url =
        this.baseAcsUrl +
        "/acs/user-tag-config/save-user-data-permission";
      let abstractTreeStructure = this.$refs.abstractTree.getStructure();
      let checkedSelected = this.$refs.instanceTree.getCheckedNodesForReadWrite(
        false
      );
      let userDataInstanceTags = [];
      if (checkedSelected && checkedSelected.length) {
        checkedSelected.forEach(checkedNode => {
          let userDataInstanceTag = {};
          userDataInstanceTag.dataTagId = checkedNode.id;
          userDataInstanceTag.isRead = checkedNode.readChecked;
          userDataInstanceTag.isWrite = checkedNode.writeChecked;
          userDataInstanceTag.isService = checkedNode.isService;
          userDataInstanceTags.push(userDataInstanceTag);
        });
      }

      let userDataInstanceTagDTO = {
        userId: this.userId,
        roleId: this.selectRole,
        userDataInstanceTags: userDataInstanceTags
      };
      let userDataAbstractTagDTO = {
        userId: this.userId,
        userDataAbstractTags: []
      };
      this.getDataAbstractTag(
        abstractTreeStructure,
        userDataAbstractTagDTO.userDataAbstractTags
      );

      let payload = {
        userDataInstanceTagDTO: userDataInstanceTagDTO,
        userDataAbstractTagDTO: userDataAbstractTagDTO
      };
      this.saveLoading = true
      this.dataLoading = true;
      this.http
        .post(url, payload)
        .then(resp => {
          this.$message.success("Successful operation ");
          this.saveLoading = false
          this.dialogVisible = false;
          this.dataLoading = false;
          this.$emit("saveSuccess");
        })
        .catch(error => {
          this.saveLoading = false
          this.dataLoading = false;
          console.info(error);
          this.$emit("saveFail");
          this.$message.warning("Operation failure");
        });
    },
    getTagAbstract() {
      let url =
        this.baseAcsUrl +
        "/acs/user-tag-config/get-user-tag-config-abstract-permission?app_key=" +
        this.appKey +
        "&user_id=" +
        this.userId;
      this.dataLoading = true;
      this.http
        .get(url)
        .then(resp => {
          this.abstractTagStructure = resp.data;
          //this.structure = resp.data;
          if (this.abstractTagStructure) {
            this.$refs.abstractTree.initIndependent(
              resp.data,
              "tagName",
              "read",
              "write"
            );
            this.getUserAbstractTag();
          }
          this.dataLoading = false;
        })
        .catch(error => {
          this.dataLoading = false;
          console.info(error);
        });
    },
    getTagInstance() {
      let url =
        this.baseAcsUrl +
        "/acs/user-tag-config/get-user-tag-config-instance-permission?app_key=" +
        this.appKey +
        "&user_id=" +
        this.userId +
        "&role_id=" +
        this.selectRole;
      this.dataLoading = true;
      this.http
        .get(url)
        .then(resp => {
          this.instanceTagStructure = resp.data.dataTagInstanceTree;
          // this.structure = resp.data;
          if (this.instanceTagStructure) {
            this.$refs.instanceTree.init(
              this.instanceTagStructure,
              "tagName",
              "read",
              "write"
            );
            this.getUserInstanceTag();
          }
          this.dataLoading = false;
        })
        .catch(error => {
          this.dataLoading = false;
          console.info(error);
        });
    },
    getUserInstanceTag() {
      let url =
        this.baseAcsUrl +
        "/acs/user-tag-config/get-user-tag-config-instance?app_key=" +
        this.appKey +
        "&user_id=" +
        this.userId +
        "&role_id=" +
        this.selectRole;
      this.dataLoading = true;
      this.http
        .get(url)
        .then(resp => {
          let readTagList = resp.data.readTagList;
          let writeTagList = resp.data.writeTagList;
          if (readTagList && readTagList.length) {
            this.$refs.instanceTree.setReadCheckboxKeys(readTagList, true);
          }
          if (writeTagList && writeTagList.length) {
            this.$refs.instanceTree.setWriteCheckboxKeys(writeTagList, true);
          }
          this.dataLoading = false;
        })
        .catch(error => {
          this.dataLoading = false;
          console.info(error);
        });
    },
    getUserAbstractTag() {
      let url =
        this.baseAcsUrl +
        "/acs/user-tag-config/get-user-tag-config-abstract?app_key=" +
        this.appKey +
        "&user_id=" +
        this.userId;
      this.dataLoading = true;
      this.http
        .get(url)
        .then(resp => {
          let nonReadTagList = resp.data.nonReadTagList;
          let nonWriteTagList = resp.data.nonWriteTagList;

          if (nonWriteTagList && nonWriteTagList.length) {
            this.$refs.abstractTree.setWriteCheckboxKeys(
              nonWriteTagList,
              false
            );
          } else {
            this.$refs.abstractTree.setWriteCheckboxKeys([], false);
          }
          if (nonReadTagList && nonReadTagList.length) {
            this.$refs.abstractTree.setReadCheckboxKeys(nonReadTagList, false);
          } else {
            this.$refs.abstractTree.setReadCheckboxKeys([], false);
          }

          this.dataLoading = false;
        })
        .catch(error => {
          this.dataLoading = false;
          console.info(error);
        });
    },
    closed() {
      // 保存完成，清空至原始状态
      // this.$refs.instanceTree.setCheckedAll( false);
      // this.$refs.abstractTree.setCheckedAll(true);
    }
  }
};
</script>


<style lang="scss" scoped>
[v-cloak] {
  display: none;
}

.breadcrumb {
  background-color: transparent !important;
  margin-bottom: 0px;
}

.title {
  margin-left: 16px;
  font-size: 20px;
}

.el-form-item /deep/ .el-select {
  display: inline-block;
  width: 86%;
}

.add-banner-group /deep/ .el-form-item__label {
  width: 148px !important;
}

.add-banner-group /deep/ .el-form-item__content {
  margin-left: 148px !important;
}
</style>



// WEBPACK FOOTER //
// src/view/acs/user/dialog/config_user_tag.vue